<geaui-page-header pageTitle="Motor Selector" [hasBackArrow]="false" [withSidebar]="true">
  <div class="UnitsSelector">
    Units:
    <mat-radio-group [(ngModel)]="isUsUnits">
      <mat-radio-button [value]="true">US</mat-radio-button>
      <mat-radio-button [value]="false">SI</mat-radio-button>
    </mat-radio-group>
  </div>
</geaui-page-header>

<div class="Content">
  <ng-container *ngIf="isLoaded">
  <div class="filters-toolbar">
    <span class="filters-button">
      <geaui-button-v3 [type]="'primary'" class="btn-brdr-radius" preIcon="system-preferences"
        (click)="openFilters(filtersDialog)">
        Filters
      </geaui-button-v3>
    </span>
    <mat-form-field class="filter-search-field">
      <mat-label class="gea-blue">Search Motors</mat-label>
      <input type="text" matInput [(ngModel)]="viewModel.Search.Value" (ngModelChange)="searchTextChanged()" />
      <button *ngIf="viewModel.Search.Value" type="button" mat-icon-button matSuffix
        aria-label="Clear search" title="Clear search" (click)="clearFilter('Search')">
        <mat-icon class="gea-blue">close</mat-icon>
      </button>
      <mat-icon matSuffix class="gea-blue">search</mat-icon>
    </mat-form-field>
  </div>

  <div class="filter-chips" *ngIf="activeFilters.length">
    <span class="filter-chips-label">Filters Applied:</span>
    <mat-chip-set aria-label="Motor filter selections">
      <mat-chip class="geaui-chip" *ngFor="let filter of activeFilters; trackBy: trackFilter" [removable]="filter.removable"
        (removed)="clearFilter(filter.key)">
        <span class="filter-chip-button" *ngIf="filter.removable">
          <button type="button" matChipRemove [attr.aria-label]="'Remove ' + filter.label">
            <mat-icon class="gea-blue">close</mat-icon>
          </button>
        </span>
        <span class="filter-chip-text">{{ filter.label }}: {{ filter.text }}</span>
      </mat-chip>
      <mat-chip class="reset-filter" removable (removed)="resetAllFilters()">
        <span class="filter-chip-text" (click)="resetAllFilters()">Reset All</span>
        <button type="button" matChipRemove aria-label="Reset all filters">
          <mat-icon class="gea-blue">replay</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-set>
  </div>

  <ng-template #filtersDialog>
    <div class="filter-dialog-header">
      <h2 mat-dialog-title>Motor Filters</h2>
    </div>
    <mat-dialog-content class="motor-filter-inputs">

  <span class="VerticalBlock">
    <span class="InputBlock">
      <span class="Label">Power Consumption:</span>
      <measurement-text-box class="Value" [(Value)]="filterViewModel.PowerConsumption.Value" [Context]="MeasurementContext.Power" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.Power) }}</span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Manufacturer:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.Manufacturer"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Voltage:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.Voltage"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Enclosure:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.Enclosure"></component-drop-down>
      <span class="Unit"></span>
    </span>
  </span>

  <span class="VerticalBlock">
    <span class="InputBlock">
      <span class="Label">Inverter Duty:</span>
      <span class="Value">
        <select aria-label="Inverter Duty" [(ngModel)]="filterViewModel.InverterDuty.Value">
          <option [ngValue]="''">All</option>
          <option [ngValue]="'Yes'">Yes</option>
          <option [ngValue]="'No'">No</option>
        </select>
      </span>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Poles:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.Poles"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Nominal Speed:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.NominalSpeed"></component-drop-down>
      <span class="Unit"></span>
    </span>
  </span>
    </mat-dialog-content>
    <div class="filter-dialog-actions">
      <button class="geaui-button-primary" type="button" (click)="applyFilterChanges()">Apply</button>
      <button class="geaui-button-secondary" type="button" (click)="cancelFilterChanges()">Cancel</button>
    </div>
  </ng-template>
  </ng-container>
  
  <div class="motor-table-wrapper">
    <div *ngIf="!isLoaded || loadingMessageVisible" class="selector-loading-overlay" role="status" aria-live="polite" aria-label="Loading motor selector">
      <div class="selector-loading-message">
        <span class="material-icons history-icon">update</span>
        <span>{{ loadingMessage }}</span>
      </div>
    </div>
  <table *ngIf="isLoaded">
    <thead>
      <tr>
        <th>Mfr.</th>
        <th>Power</th>
        <th>Voltage</th>
        <th>Enclosure</th>
        <th>Inverter Duty</th>
        <th>Frame</th>
        <th>Poles</th>
        <th>Nom Speed</th>
        <th>FLA</th>
        <th>LRA</th>
        <th>Eff</th>
        <th>P. Factor</th>
        <th>PUT</th>
        <th>FLT</th>
        <th scope="col" aria-label="Motor details"></th>
      </tr>
      <tr style="font-style: italic; background-color: #f5f5f5;">
        <td></td>
        <td>{{ getUnitText(MeasurementContext.Power) }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{ getUnitText(MeasurementContext.Speed) }}</td>
        <td>(A)</td>
        <td>(A)</td>
        <td>(%)</td>
        <td>(%)</td>
        <td>{{ getUnitText(MeasurementContext.Torque) }}</td>
        <td>{{ getUnitText(MeasurementContext.Torque) }}</td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let motor of viewModel.VisibleMotors.Value; let motorIndex = index">
      <tr>
        <td>{{ manufacturerDescriptions.get(motor.Manufacturer) ?? motor.Manufacturer }}</td>
        <td>{{ formatUnits(motor.Power, MeasurementContext.Power, 1) }}</td>
        <td>{{ motor.Voltage }}/{{ motor.Phase }}/{{ motor.Frequency }}</td>
        <td>{{ enclosureDescriptions.get(motor.Enclosure) ?? motor.Enclosure }}</td>
        <td>{{ motor.InverterDuty ? 'Yes' : 'No' }}</td>
        <td>{{ motor.Frame }}</td>
        <td>{{ motor.Poles }}</td>
        <td>{{ formatUnits(motor.Speed, MeasurementContext.Speed, 0) }}</td>
        <td>{{ motor.FullLoadAmps }}</td>
        <td>{{ motor.LockedRotorAmps }}</td>
        <td>{{ motor.EfficiencyValue }}</td>
        <td>{{ motor.PowerFactor }}</td>
        <td>{{ formatUnits(motor.PullUpTorque, MeasurementContext.Torque, 0) }}</td>
        <td>{{ formatUnits(motor.FullLoadTorque, MeasurementContext.Torque, 0) }}</td>
        <td class="motor-info-cell">
          <button type="button" mat-icon-button (click)="toggleMotorDetails(motor)"
            [attr.aria-expanded]="expandedMotor === motor" [attr.aria-controls]="'motor-details-' + motorIndex"
            [attr.aria-label]="expandedMotor === motor ? 'Hide motor details' : 'Show motor details'"
            [matTooltip]="expandedMotor === motor ? 'Hide motor details' : 'Show motor details'">
            <mat-icon>info</mat-icon>
          </button>
        </td>
      </tr>
      <tr *ngIf="expandedMotor === motor" [id]="'motor-details-' + motorIndex">
        <td colspan="15" class="motor-details-cell">
          <table class="motor-details-table">
            <caption>Motor Details</caption>
            <tbody>
              <tr *ngFor="let field of motorDetailFields">
                <th scope="row">{{ field.label }}</th>
                <td>{{ motorDetailValue(motor, field) }}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      </ng-container>
    </tbody>
  </table>
  </div>
</div>